var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2801_8886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.5 0 0 4.44944 0 9.88764C0 12.03 0.666667 14.0075 1.83333 15.6554V20.9288C1.83333 21.9176 3 22.412 3.75 21.6704L6.33333 19.1161C7.5 19.5281 8.75 19.7753 10 19.7753C15.5 19.7753 20 15.3258 20 9.88764C20 4.44944 15.5 0 10 0Z",
    fill: "#EDDFF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9163 8.8989H10.9163V5.93261C10.9163 5.43823 10.4997 4.94385 9.91634 4.94385C9.33301 4.94385 8.91634 5.35583 8.91634 5.93261V8.8989H6.08301C5.58301 8.8989 5.08301 9.31089 5.08301 9.88767C5.08301 10.3821 5.49967 10.8764 6.08301 10.8764H9.08301V13.8427C9.08301 14.3371 9.49967 14.8315 10.083 14.8315C10.6663 14.8315 11.083 14.4195 11.083 13.8427V10.8764H14.083C14.583 10.8764 15.083 10.4644 15.083 9.88767C14.9163 9.31089 14.4997 8.8989 13.9163 8.8989Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2801_8886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvice);
export default __webpack_public_path__ + "static/media/advice.39c3c5c3b55d693014268657442485d0.svg";
export { ForwardRef as ReactComponent };